// extracted by mini-css-extract-plugin
module.exports = {"microsoft-logo":"MicrosoftLogo_microsoft-logo__2JqwH"};